import { grey } from "@mui/material/colors";

const styles = {
  container: {
    alignItems: "center",
    display: "flex",
    background: "#f7f7f5",
    borderRadius: 8,
    ml: 1,
    px: 1,
    py: 1,
    width: "max-content",
  },
  inactive: {
    color: grey[600],
    textTransform: "none",
    borderRadius: 4,
    fontSize: 13,
  },
  button: {
    px: { xs: 1, md: 2 },
    fontSize: { xs: 11, md: 13 },
    "&:hover": {
      backgroundColor: grey[100],
    },
  },
  active: {
    borderRadius: 4,
    backgroundColor: "white",
    color: "black",
    textTransform: "none",
  },
  yearlyText: {
    color: "purple.main",
    fontSize: { xs: 10, md: 12 },
    ml: 1,
  },
  promoInactive: {
    color: "primary.main",
    textTransform: "none",
    borderRadius: 4,
    fontSize: 13,
  },
  promoActive: {
    borderRadius: 4,
    backgroundColor: "yellow.main",
    color: "primary.dark",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "yellow.main",
      filter: "brightness(0.96)",
    },
  },
  limitedText: {
    fontSize: { xs: 10, md: 12 },
    ml: 1,
    fontWeight: 700,
    color: "primary.dark",
  },
};

export default styles;
